

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface DepartmentParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Department {
    id?: any;
    name: string;
    tenantId?: string;
    brandId?: string;
    code: string;
    snomedCode: number;
    isClinical: string;
    departmentId?: string;
    isActive?:Boolean;
    caseSheet?: Array <any>;
	assignedBranches?:string;
  parameters?: DepartmentParameter[];
  links?: any;
  branchId:string;
}

export abstract class DepartmentData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<Department[]>;
  abstract create(url: string,data: Department): Observable<any>;
  abstract update(url: string,data: Department): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
